import {container} from '@/shared/config/Container';
import {ProductStore} from '../stores/ProductStore';
import {OrderStore} from '../stores/OrderStore';
import {AuthStore} from '../stores/AuthStore';
import {PaymentStore} from '../stores/PaymentStore';
import {CheckoutStore} from '../stores/CheckoutStore';
import {ModalStore} from '../stores/ModalStore';
import {RepScoreStore} from '../stores/RepScoreStore';
import {Pay4MeStore} from '../stores/Pay4MeStore';

export const useStores = () => {
    return {
        productStore: container.productStore,
        orderStore: container.orderStore,
        authStore: container.authStore,
        paymentStore: container.paymentStore,
        checkoutStore: container.checkoutStore,
        modalStore: container.modalStore,
        repScoreStore: container.repScoreStore,
        pay4meStore: container.pay4meStore,
    };
};

export const useProductStore = (): ProductStore => {
    return container.productStore;
};

export const useOrderStore = (): OrderStore => {
    return container.orderStore;
};

export const useAuthStore = (): AuthStore => {
    return container.authStore;
};

export const usePaymentStore = (): PaymentStore => {
    return container.paymentStore;
};

export const useCheckoutStore = (): CheckoutStore => {
    return container.checkoutStore;
};

export const useModalStore = (): ModalStore => {
    return container.modalStore;
};

export const useRepScoreStore = (): RepScoreStore => {
    return container.repScoreStore;
};

export const usePay4MeStore = (): Pay4MeStore => {
    return container.pay4meStore;
};
